import { Customer } from "shared";

export function formatCustomerAddress({
  line1,
  line2,
  city,
  state,
  postalCode,
}: Customer): string {
  if (line1) {
    return line2
      ? `${line1} ${line2}, ${city}, ${state} ${postalCode}`
      : `${line1}, ${city}, ${state} ${postalCode}`;
  } else {
    return "Not provided";
  }
}
